"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/aphrodite/~/inline-style-prefixer/utils/capitalizeString.js
// module id = 393
// module chunks = 6